module.exports = __webpack_public_path__ + "static/cooperl-f23610af149fa0ed5017d7ec90aaf376.ttf";